import React from 'react';
import { AgTechClickEventHandler, AgTechButton } from '../../../../../Buttons/AgTechButtons';

export type AgTechSideNavigationButtonProps = {
    icon: string,
    text: string,
    role?: string,
    permission?: string,
    action: (e: AgTechClickEventHandler) => void,
    isCollapsed: boolean,
    isActive?: boolean
}

const AgTechSideNavigationButton = (props: AgTechSideNavigationButtonProps) => {
    return (
        <AgTechButton
            classes={`button-link text-white text-plus font-semibold justify-start px-[26px] py-4 mb-3 flex`}
            text={props.isCollapsed ? undefined : props.text}
            icon={props.icon}
            iconClasses='mr-5'
            role={props.role}
            permission={props.permission}
            action={props.action}
        />
    )
}

export default AgTechSideNavigationButton;